import { useMemo } from "react"
import { Dropdown, Popover } from "antd"
import styles from "@css/modules/Listing.module.scss"
import { ArrowDownSmall } from "@css/icons/SVG"

const onPointsChange = (event) => {
    const value = Number(event.target.value)
    if (value > 2000) {
        event.target.value = 2000
    }
}
const currentYear = new Date().getFullYear()

export function Controls({ resorts, resortId, years, year, points, changePoints, changeYear, onChangeResort, resortName }) {
    const resort = useMemo(() => {
        return resorts.find((i) => i.id === resortId)
    }, [resortId, resorts])
    const renderPoints = () => {
        const handler = (e) => {
            const newPoints = Number(e.target.value)
            if (points === newPoints) return
            if (!isNaN(newPoints)) {
                changePoints(newPoints)
            }
        }
        return (
            <div>
                <input type="number" onChange={onPointsChange} defaultValue={points} onBlur={handler} onKeyPress={(e) => e.key === "Enter" && handler(e)} />
            </div>
        )
    }
    const renderResorts = useMemo(() => {
        return {
            selectedKeys: [resortId.toString()],
            onClick: ({ key }) => onChangeResort(Number(key)),
            items: resorts.map((i) => {
                return {
                    label: i.short_name,
                    key: i.id
                }
            })
        }
    }, [resortId, resorts])
    const renderYears = useMemo(() => {
        return {
            selectedKeys: [year?.toString()],
            onClick: ({ key }) => changeYear(Number(key)),
            items: years.map((i) => {
                return {
                    label: i,
                    key: i
                }
            })
        }
    }, [year, years])
    return (
        <div className={styles.pointsSummaryControls}>
            How far does&nbsp;
            <Popover trigger="click" overlayClassName={styles.pointsSummaryControlsPopover} content={renderPoints} title="Points on contract" placement="bottom" arrowPointAtCenter>
                <span className={styles.control}>
                    {points} points <ArrowDownSmall />
                </span>
            </Popover>
            {" go?"}
            <div className={styles.controlsLevel2}>
                While vacationing at the&nbsp;
                <Dropdown menu={renderResorts} arrow overlayClassName={styles.pointsSummaryControlsDropDown} trigger="click">
                    <span className={styles.control}>
                        {resort?.short_name || resortName} <ArrowDownSmall />
                    </span>
                </Dropdown>
                &nbsp;in&nbsp;
                <Dropdown menu={renderYears} arrow overlayClassName={styles.pointsSummaryControlsDropDown} trigger="click">
                    <span className={styles.control}>
                        {year || currentYear} <ArrowDownSmall />
                    </span>
                </Dropdown>
            </div>
        </div>
    )
}
